import { Component, OnInit, TemplateRef, viewChild, inject } from '@angular/core';
import { ActionFormData } from '../../custom-field-parameter/action-form-data';
import {
  BrowserMessagesService,
  ModalRef,
  ModalService,
  UserService,
  SideMenuHeadlineComponent
} from '@rbb/ng-web-template-lib';
import { ApproverFormData } from '../../custom-field-parameter/approver-form-data';
import { ApproverDataToJson } from '../../data-to-json/approver-data-to-json';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../services/form.service';
import { Form } from '../../data/form';
import { BodyApproved } from '../../body/body-approved';
import { FormComponent } from '../form/form.component';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';

@Component({
  selector: 'app-data-protection-officer-form',
  templateUrl: './data-protection-officer-form.component.html',
  styleUrls: ['./data-protection-officer-form.component.css'],
  imports: [FormComponent, PrivacyPolicyComponent, SideMenuHeadlineComponent]
})
export class DataProtectionOfficerFormComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private formService = inject(FormService);
  private userService = inject(UserService);
  private browserMessagesService = inject(BrowserMessagesService);
  private modalService = inject(ModalService);
  private router = inject(Router);

  form: Form | undefined;
  formId: string;

  decline: boolean | undefined;

  readonly ngModalApprove = viewChild<TemplateRef<unknown>>('ngModalApprove');
  ngModalServiceApprove: ModalRef<unknown> | undefined;

  constructor() {
    this.formId = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.getForm(this.formId);
  }

  getForm(id: string): void {
    this.formService.getForm(id).subscribe({
      next: (next) => {
        this.form = next;
        this.form.timestamp = new Date();
        this.form.actionDataCustomParameter = new ActionFormData(this.form.actionData);

        const tmpApproverData: ApproverFormData[] = this.form.approverData ? JSON.parse(this.form.approverData) : [];
        this.form.approverDataCustomParameter = new Array<ApproverDataToJson>(tmpApproverData.length);
        for (let i = 0; i < tmpApproverData.length; i++) {
          if (!tmpApproverData[i]) {
            this.form.approverDataCustomParameter[i] = new ApproverDataToJson();
          } else {
            const tmpUser = new ApproverDataToJson();
            this.form.approverDataCustomParameter[i] = tmpUser;
            const username = tmpApproverData[i].username;
            if (username) {
              this.userService.getAdUsers([username], {}).subscribe({
                next: (approver) => {
                  tmpUser.users = approver;
                },
                error: (error) => {
                  this.browserMessagesService.showHttpError(error, 'Daten zu den Genehmigern konnten nicht geladen werden');
                }
              });
            }
            const deputyUsername = tmpApproverData[i].deputyUsername;
            if (deputyUsername) {
              this.userService.getAdUsers([deputyUsername]).subscribe({
                next: (approver) => {
                  tmpUser.deputyUsers = approver;
                },
                error: (error) => {
                  this.browserMessagesService.showHttpError(error, 'Daten zu den Genehmigern konnten nicht geladen werden');
                }
              });
            }
          }
        }
        this.form.dataFieldsCustomParameter = this.form.dataFields ? JSON.parse(this.form.dataFields) : [''];
        if (this.form.fields) {
          for (let i = 0; i < this.form.fields.length; i++) {
            this.form.fields[i].fieldCustomParameter = JSON.parse(this.form.fields[i].definition ?? '{}');
            this.form.fields[i].order = i + 1;
          }
        }
      },
      error: () => {
        this.formService.getLatestFormId(id, true).subscribe({
          next: (next) => {
            if (next.value) {
              this.router.navigateByUrl('/data-protection-officer/' + next.value).then();
              this.formId = next.value;
              this.getForm(this.formId);
            } else {
              this.router.navigateByUrl('/list').then();
            }
          },
          error: (error) => {
            this.browserMessagesService.showHttpError(error, 'Formular konnte nicht gefunden werden');
            this.router.navigateByUrl('/list').then();
          }
        });
      }
    });
  }

  openModalApprove(decline: boolean): void {
    this.decline = decline;
    const ngModalApprove = this.ngModalApprove();
    if (ngModalApprove) {
      this.ngModalServiceApprove = this.modalService.open(ngModalApprove, { centered: true, backdrop: 'static' });
    }
  }

  closeModalApprove(): void {
    this.ngModalServiceApprove?.close();
  }

  declineForm(): void {
    this.dataProtectionOfficerApproval(false);
  }

  acceptForm(): void {
    this.dataProtectionOfficerApproval(true);
  }

  dataProtectionOfficerApproval(approve: boolean): void {
    if (this.form?.id) {
      this.formService.dataProtectionOfficerApproval(new BodyApproved(approve), this.form.id).subscribe({
        next: () => {
          this.closeModalApprove();
          this.router.navigateByUrl('/data-protection-officer').then();
        },
        error: (error) => {
          this.browserMessagesService.showHttpError(error, 'Formular konnte nicht genehmigt/abgelehnt werden.');
        }
      });
    }
  }

  print(): void {
    window.print();
  }
}
